var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoPerfil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_13164",
    "data-name": "Grupo 13164",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.105,
    height: 17.474,
    viewBox: "0 0 13.105 17.474",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_30976",
    "data-name": "Trazado 30976",
    d: "M183.731,410.33a4.368,4.368,0,1,0-4.369-4.368A4.368,4.368,0,0,0,183.731,410.33Zm0-7.281a2.913,2.913,0,1,1-2.912,2.913A2.913,2.913,0,0,1,183.731,403.049Z",
    transform: "translate(-177.178 -401.593)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_30977",
    "data-name": "Trazado 30977",
    d: "M183,415.184a6.56,6.56,0,0,0-6.553,6.553.728.728,0,1,0,1.456,0,5.1,5.1,0,1,1,10.193,0,.728.728,0,1,0,1.456,0A6.56,6.56,0,0,0,183,415.184Z",
    transform: "translate(-176.45 -404.991)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoPerfil);
export default __webpack_public_path__ + "static/media/Icono-Perfil.84729944ef2901c704cc6b3ef31917b8.svg";
export { ForwardRef as ReactComponent };